import React, { useState } from 'react';
import { Card, Row, Col, Button, Pagination } from 'antd'; // 1. Import Pagination
import { EyeOutlined, LikeOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const { Meta } = Card;

const ArticleCardList = ({ articles }) => {
    const navigate = useNavigate();

    // 2. Add state for the current page, starting at page 1
    const [currentPage, setCurrentPage] = useState(1);

    // 3. Define the number of articles to show per page
    const pageSize = 9;

    const handleReadMore = (article) => {
        navigate(`/articles/${article.id}`);
    };

    // 4. Calculate the articles to display on the current page
    const indexOfLastArticle = currentPage * pageSize;
    const indexOfFirstArticle = indexOfLastArticle - pageSize;
    const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);

    // 5. Create a handler to update the page state when the user clicks a new page
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const metaTitleStyle = {
      whiteSpace: 'normal', // Allows the text to wrap onto multiple lines
      overflow: 'visible', // Ensures text is not hidden
      textOverflow: 'unset', // Prevents the ellipsis (...)
      display: '-webkit-box', // Needed for potential multi-line ellipsis if you decide to limit lines later
      WebkitLineClamp: 'unset', // Ensures no line limit is enforced
      WebkitBoxOrient: 'vertical',
  };

    return (
        <div style={{ padding: '20px' }}>
            <Row gutter={[16, 16]}>
                {/* 6. Map over the 'currentArticles' slice instead of the full array */}
                {currentArticles.map((article) => (
                    <Col key={article.id} xs={24} sm={12} md={8} lg={8}>
                        <Card
                            onClick={() => handleReadMore(article)}
                            hoverable
                            cover={
                                <img
                                    alt={article.title}
                                    src={article.coverUrl || '/default.jpg'}
                                    style={{ height: '200px', objectFit: 'cover' }}
                                />
                            }
                            actions={[
                                <Button type="primary" onClick={(e) => { e.stopPropagation(); handleReadMore(article); }}>
                                    Read More
                                </Button>,
                            ]}
                        >
                            <Meta title={
                                    <span style={metaTitleStyle}>
                                        {article.title}
                                    </span>
                                } description={`Published: ${moment(article.createdAt).format('LL')}`} />
                            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                <span>
                                    <EyeOutlined /> {article.views} Views
                                </span>
                                <span>
                                    <LikeOutlined /> {article.likes.length} Likes
                                </span>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* 7. Add the Pagination component at the bottom */}
            <Row justify="center" style={{ marginTop: '20px' }}>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={articles.length}
                    onChange={handlePageChange}
                    showSizeChanger={false} // Optional: hide the "items per page" selector
                />
            </Row>
        </div>
    );
};

export default ArticleCardList;